import { FC } from 'react'
import HeroBanner from 'components/hero/HeroBanner'
import KonnectForm from 'components/sections/KonnectForm'
import SeoContainer from 'components/util/containers/SeoContainer'
import TrustedPartners from 'components/accountancy-landing-pages/TrustedPartners'
import OurClientsAndPartnerships from 'components/accountancy-landing-pages/OurClientsAndPartnerships'
import ZeroUpfrontCard from 'components/accountancy-landing-pages/ZeroUpfrontCard'
import { sectionGap, sectionGapSmall, sectionPadding } from '../project/padding'
import classNames from 'classnames'
import Supademo from 'components/Supademo'
import EnquireNowButton from 'components/accountancy-landing-pages/EnquireNowButton'
import Button from 'components/forms/Button'

type AccountancyTodayPageType = {}

const AccountancyTodayPage: FC<AccountancyTodayPageType> = ({}) => {
  return (
    <SeoContainer breadcrumb={[]} noIndex>
      <main className={'mb-lg-25 mb-8'}>
        <div className='mb-md-48 mb-14'>
          <HeroBanner
            hideFooter
            titleSize='small'
            robotImage={{
              alt: 'HaiRo™ robot mascot holding tie',
              dimensions: {
                height: 957,
                width: 702,
              },
              src: '/images/new/robot-enterprise.png',
            }}
            title='Helping Accounting Firms Provide Virtual & Registered Address Services since 2010.'
            cta={
              <a href='#konnect-form' className='btn btn-lg btn-black'>
                Book a Demo
              </a>
            }
            description={
              <span className='fs-fluid-18-22 fw-semibold'>
                We simplify mail processing for accountancy firms and their clients, saving time and effort and unnecessary chasing,especially as postal volumes increase. All mail is digitised and processed within one business day and available to view via email, our portal or via our mobile app.
                <br/>
                <br/>
                However you choose to integrate our SaaS products, our enterprise tools have you covered.
                Whether you prefer a plug-and-play dashboard or a fully white-label API, our tools are built for flexibility.
                <br/>
                <br/>
                Our partner plan includes Registered Office Address, Director’s Service Address for all company PSCs and the scanning of all business mail.
                <br/>
                <br/>
                Our AI-powered scanning system provides full audit tracking, workflow management and mail is scanned within 1-business day. Flexible pricing based on client volumes.
<br/>
<br/>
              </span>
            }
            subtitle={
              <span className='fw-semibold fs-fluid-24-26'>
                However you choose to integrate, our enterprise tools have you
                covered.
              </span>
            }
          />
        </div>
        <div className={classNames(sectionGap, 'container d-flex flex-column')}>
          <div>
            <ZeroUpfrontCard />
            <EnquireNowButton className="mb-0" />
          </div>
          <div className={`d-none d-lg-flex flex-column ${sectionGapSmall}`}>
            <div className={classNames('d-flex flex-column', sectionGapSmall)}>
              <div className={classNames(sectionPadding, 'd-flex flex-column')}>
                <h2
                  id='demo'
                  className={classNames(
                    'fs-fluid-36-80 lh-105 fw-semibold text-center',
                  )}
                >
                  Our <span className='color-pink2'>Partner Portal</span>.
                </h2>
                <h3
                  style={{
                    maxWidth: 682,
                  }}
                  className='fw-semibold text-muted mt-lg-3 mt-2 text-center fs-fluid-20-36 mx-auto'
                >
                  With the Partner Portal, you can manage your clients
                  seamlessly and efficiently.
                </h3>
              </div>
              <div>
                <Supademo showcaseId={'cmbs3di7n00vy090ismxakcn0'} />
                <div className='d-flex justify-content-center align-items-center mt-lg-16'>
                  <Button className='w-100 w-lg-auto'>Book a demo</Button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <OurClientsAndPartnerships />
            <TrustedPartners className="mb-0" />
          </div>
          <KonnectForm />
        </div>

      </main>
    </SeoContainer>
  )
}

export default AccountancyTodayPage
